import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dreamy%20romantic%20atmosphere%20with%20soft%20pastel%20pink%20and%20peach%20tones%2C%20floating%20cherry%20blossom%20petals%2C%20delicate%20golden%20sparkles%2C%20elegant%20abstract%20background%20with%20soft%20bokeh%20lights%2C%20warm%20and%20inviting%20literary%20mood%2C%20no%20text%2C%20minimalist%20composition&width=1600&height=900&seq=hero-bg-po18&orientation=landscape"
          alt="po18脸红心跳 - 言情小说推荐"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          脸红心跳的
          <span className="block mt-1 text-primary-400">爱情故事</span>
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          po18脸红心跳汇聚甜宠、虐恋、霸总等热门言情小说，精选最受欢迎的脸红心跳系列，带你沉浸在每一个动人的爱情世界中。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/全部"
            className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/40 text-white rounded-full text-sm md:text-base font-medium hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">
              20000+
            </p>
            <p className="text-xs md:text-sm text-white/60 mt-1">精选小说</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">
              500万+
            </p>
            <p className="text-xs md:text-sm text-white/60 mt-1">忠实读者</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">
              100万+
            </p>
            <p className="text-xs md:text-sm text-white/60 mt-1">读者好评</p>
          </div>
        </div>
      </div>
    </section>
  );
}